/**
 * Visual tokens of the producer event-panel look (reference: Avaliações).
 * How to apply: apps/web/DESIGN.md
 */
export const panelPage = "space-y-6 pb-12";

export const panelEyebrow =
  "text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground sm:tracking-[0.18em]";

export const panelTitle = "font-display text-2xl font-semibold tracking-[-0.03em]";

export const panelSurface =
  "overflow-hidden rounded-[28px] border border-border/60 bg-white dark:bg-card";

export const panelSectionHeader = "border-b border-border/60 px-5 py-4 sm:px-6";

export const panelSectionTitle = "font-display text-base font-semibold tracking-tight";

/** 6px coral mark — the only idle orange inside a form card. */
export const panelAccentDot = "h-1.5 w-1.5 shrink-0 rounded-full bg-primary";

export const panelBody = "space-y-7 p-5 sm:p-7";

export const panelFieldLabel = "text-sm font-medium text-foreground";

/** Soft well — neutral Apple focus ring without orange contours. */
export const panelControl =
  "mt-2 h-12 rounded-2xl border-transparent bg-secondary/50 px-4 shadow-none text-sm font-medium hover:bg-secondary/70 focus:ring-1 focus:ring-border/80 focus:ring-offset-0 focus-visible:ring-1 focus-visible:ring-border/80 focus-visible:ring-offset-0 focus-visible:border-transparent focus-visible:bg-background focus:outline-none focus-visible:outline-none transition-[background-color,box-shadow] duration-150 ease-out";


export const panelHint = "mt-1.5 text-[11px] leading-relaxed text-muted-foreground/80";

export const panelPill =
  "rounded-full active:scale-[0.97] transition-transform duration-150 ease-out";

export const panelRow = "rounded-[22px] border border-border/60 bg-card";

export const panelEmpty = "rounded-[28px] border border-dashed border-border/70";

export const panelDialog =
  "rounded-[28px] border-border/60 bg-card p-0 overflow-hidden shadow-none sm:rounded-[28px]";

export const panelAlert =
  "rounded-[28px] border-border/60 sm:rounded-[28px] sm:max-w-md";

export const panelChoice =
  "flex cursor-pointer flex-col rounded-2xl bg-secondary/50 p-4 text-left transition-colors duration-150 ease-out hover:bg-secondary/70";

export const panelChoiceOn = "bg-background ring-1 ring-primary/30";

export const panelEase = [0.23, 1, 0.32, 1] as const;
